import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  showSuccesChangePassword: false,
  title: null,
  icon: null,
  updatePasswordToken: null,
  sidebar: true,
  loading: false,
  menuOpen: null,
  menuSelected: null
}

export const uiSlice = createSlice({
  name: 'ui',
  initialState,
  reducers: {
    setUpdatePasswordToken: (state, action) => ({
      ...state,
      updatePasswordToken: action.payload
    }),
    setShowSuccesChangePassword: (state, action) => ({
      ...state,
      showSuccesChangePassword: action.payload
    }),
    setTitle: (state, action) => ({
      ...state,
      title: action.payload
    }),
    setIcon: (state, action) => ({
      ...state,
      icon: action.payload
    }),
    showSidebar: (state, action) => ({
      ...state,
      sidebar: action.payload
    }),
    setLoading: (state, action) => ({
      ...state,
      loading: action.payload
    }),
    setMenuOpen: (state, action) => ({
      ...state,
      menuOpen: action.payload
    }),
    setMenuSelected: (state, action) => ({
      ...state,
      menuSelected: action.payload
    }),
    clean: () => initialState
  }
})

export const { setUpdatePasswordToken, setShowSuccesChangePassword, setTitle, setIcon, showSidebar, setLoading, setMenuOpen, setMenuSelected, clean } = uiSlice.actions

export default uiSlice.reducer

